export default function Benefits() {
  return (
    <div className="benefits">
      <div className="card benefit">
        <div>
          <img src="images/svg/clock.svg" alt="Save time" />
        </div>
        <div className="benefit__text">
          <div className="benefit__title">Vähem käsitööd</div>
          <div className="benefit__content">
            Korralda hankeid minutitega või automatiseeri kogu vedelkütuse ostuprotsess.
          </div>
        </div>
      </div>
      <div className="card benefit">
        <div>
          <img src="images/svg/settings.svg" alt="Settings" />
        </div>
        <div className="benefit__text">
          <div className="benefit__title">Andmepõhine töövoog</div>
          <div className="benefit__content">
            Ühenda turuinfo, mahutid ja tarnijad ühte süsteemi ning tee paremaid ostuotsuseid.
          </div>
        </div>
      </div>
      <div className="card benefit">
        <div>
          <img src="images/svg/graphic.svg" alt="Save money" />
        </div>
        <div className="benefit__text">
          <div className="benefit__title">Parem hind</div>
          <div className="benefit__content">
            Vedelkütuse hankele tehakse mitmeid pakkumisi, mille seast saab hanke korraldaja valida sobivaima pakkumise.
          </div>
        </div>
      </div>
    </div>
  );
}
